import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor(private snackbar: MatSnackBar) { }

  handleError(msg: string, timout: number = 2500) {
    this.snackbar.open(msg, 'x', {verticalPosition : 'top', panelClass: 'snack-bar-error', duration: timout})
  }
}
